import React, { Component } from "react";
import "../style/Explore.css";
import ExploreTile from "../components/ExploreTile";
import ExploreFilter from "../parts/ExploreFilter";
import metadataJson from "../assets/metadata_completed.json";
import soldTokensJson from "../assets/sold_tokens.json";

const SOLD_TOKENS_IDS = soldTokensJson.ids;

export class Explore extends Component {
  componentDidMount() {
    Object.keys(metadataJson).forEach((key) => {
      if (SOLD_TOKENS_IDS.includes(key)) delete metadataJson[key];
    });
    const data = Object.keys(metadataJson).map((key) => {
      return metadataJson[key];
    });
    this.loadInitalMedatata(data);
  }

  constructor(props) {
    super();
    this.state = {
      metadata: [],
      currentMetadata: [],
      currentFilteredMetadata: [],
      currentMetadataItemsNumber: 20,
      currentFilteredMetadataItemsNumber: 20,
      isFiltered: false,
      isTraitsFiltered: false,
      searchedName: "",
      traits: [],

      gadgets: [],
      body: "",
    };
    this.toggleFilterPopup = this.toggleFilterPopup.bind(this);
    this.loadMoreMetadata = this.loadMoreMetadata.bind(this);
    this.loadMoreFilteredMetadata = this.loadMoreFilteredMetadata.bind(this);
    this.loadMoreTraisFilteredMetadata = this.loadMoreTraisFilteredMetadata.bind(
      this
    );
    this.clearFilter = this.clearFilter.bind(this);
    this.filterMetadata = this.filterMetadata.bind(this);
    this.filterMetadataByTrait = this.filterMetadataByTrait.bind(this);
    this.filterInputRef = React.createRef();
  }

  toggleFilterPopup() {
    this.setState(
      {
        isFilterPopupShown: !this.state.isFilterPopupShown,
      },
      () => {
        if (this.state.isFilterPopupShown) {
          document.body.style.overflow = "hidden";
        } else {
          document.body.style.overflow = "auto";
        }
      }
    );
  }

  filterPopup() {
    if (this.state.isFilterPopupShown) {
      return (
        <ExploreFilter
          filterMetadataByTrait={this.filterMetadataByTrait}
          toggleFilterPopup={this.toggleFilterPopup}
        />
      );
    }
  }

  loadInitalMedatata(data) {
    this.setState({
      metadata: data,
      currentMetadata: data.slice(0, this.state.currentMetadataItemsNumber),
    });
  }

  loadMoreMetadata() {
    this.setState({
      currentMetadata: this.state.metadata.slice(
        0,
        this.state.currentMetadataItemsNumber + 20
      ),
      currentMetadataItemsNumber: this.state.currentMetadataItemsNumber + 20,
    });
  }

  loadMoreFilteredMetadata() {
    // this.setState({
    //     currentFilteredMetadata: this.state.metadata.filter(frog => frog.name.includes(this.state.searchedName)).slice(0, this.state.currentFilteredMetadataItemsNumber + 20),
    //     currentFilteredMetadataItemsNumber: this.state.currentFilteredMetadataItemsNumber + 20,
    // }, () => {
    //     console.log(this.state.currentFilteredMetadata)
    // })
    this.setState(
      {
        currentFilteredMetadataItemsNumber:
          this.state.currentFilteredMetadataItemsNumber + 20,
      },
      () => {
        this.filterMetadata("gadget");
      }
    );
  }

  loadMoreTraisFilteredMetadata() {
    if (this.state.traits.length > 0) {
      let metadata = [...this.state.metadata];
      this.state.traits.forEach((trait) => {
        if (trait.type === "body") {
          metadata = [
            ...metadata
              .filter((frog) => frog.body === trait.name)
              .splice(0, this.state.currentFilteredMetadataItemsNumber + 20),
          ];
        } else {
          metadata = [
            ...metadata
              .filter((frog) => frog.gadgtes.include === trait.name)
              .splice(0, this.state.currentFilteredMetadataItemsNumber + 20),
          ];
        }
      });
      this.setState({
        isTraitsFiltered: true,
        currentMetadata: metadata,
        currentFilteredMetadataItemsNumber:
          this.state.currentFilteredMetadataItemsNumber + 20,
      });
    }
  }

  filterMetadataByTrait(gadgets, body) {
    // if(traits.length > 0){
    //     let metadata = [...this.state.metadata];
    //     traits.forEach(trait => {
    //         if(trait.type === "body"){
    //             metadata = [...metadata.filter(frog => frog.body === trait.name).splice(0, this.state.currentFilteredMetadataItemsNumber)];
    //         }
    //         else{
    //             console.log(metadata[0].gadgets.includes(trait.name))
    //             metadata = [...metadata.filter(frog => frog.gadgtes.includes(trait.name)).splice(0, this.state.currentFilteredMetadataItemsNumber)];
    //         }
    //     })
    //     this.setState({
    //         isTraitsFiltered: true,
    //         traits:[...traits],
    //         //currentFilteredMetadata: metadata,
    //         currentMetadata: metadata,
    //     })
    // }
    if (gadgets.length > 0 || body != "") {
      this.setState(
        {
          isFiltered: true,
          body: body,
          gadgets: [...gadgets],
        },
        () => {
          this.filterMetadata("gadget");
        }
      );
    }
  }

  doesFrogHaveGivenGadgets(frog, gadgets) {
    return gadgets.every((gadget) => frog.gadgets.includes(gadget));
  }

  filterMetadata(type) {
    // let searchedName = this.filterInputRef.current.value;
    // if (searchedName === "") {
    //     this.setState({
    //         // currentMetadata: this.state.metadata.slice(0, this.state.currentMetadataItemsNumber),
    //         isFiltered: false
    //     })
    // }
    // else {
    //     this.setState({
    //         isFiltered: true,
    //         searchedName: searchedName,
    //         currentFilteredMetadata: this.state.metadata.filter(frog => frog.name.includes(searchedName)).splice(0, this.state.currentFilteredMetadataItemsNumber),
    //     }, () => {
    //         console.log(this.state.currentFilteredMetadata)
    //     })
    // }
    if (type == "name") {
      let searchedName = this.filterInputRef.current.value;
      if (searchedName === "") {
        this.setState({
          // currentMetadata: this.state.metadata.slice(0, this.state.currentMetadataItemsNumber),
          isFiltered: false,
        });
      } else {
        this.setState(
          {
            isFiltered: true,
            searchedName: searchedName,
            currentFilteredMetadata: this.state.metadata
              .filter((frog) => frog.name.includes(searchedName))
              .splice(0, this.state.currentFilteredMetadataItemsNumber),
          },
          () => {}
        );
      }
    } else if (type == "gadget") {
      this.setState(
        {
          currentFilteredMetadata: this.state.metadata
            .filter((frog) => {
              if (this.state.body != "" && this.state.gadgets.length > 0) {
                return (
                  this.doesFrogHaveGivenGadgets(frog, this.state.gadgets) &&
                  frog.body == this.state.body
                );
              } else if (
                this.state.body == "" &&
                this.state.gadgets.length > 0
              ) {
                return this.doesFrogHaveGivenGadgets(frog, this.state.gadgets);
              } else if (
                this.state.body != "" &&
                this.state.gadgets.length <= 0
              ) {
                return frog.body == this.state.body;
              } else {
                return true;
              }
            })
            .splice(0, this.state.currentFilteredMetadataItemsNumber),
        },
        () => {}
      );
    }
  }

  clearFilter() {
    this.filterInputRef.current.value = "";
    this.setState({
      isFiltered: false,
      searchedName: "",
      gadgets: [],
      body: "",
    });
  }

  filterBtnContent() {
    if (this.state.isFiltered) {
      return (
        <div>
          Clear&nbsp; <i className="fas fa-times"></i>
        </div>
      );
    }
    return (
      <div>
        Filter&nbsp; <i className="fas fa-filter"></i>
      </div>
    );
  }

  render() {
    return (
      <div id="explore">
        {this.filterPopup()}
        <div id="exploreNav">
          <div id="exploreSearchBar">
            <input
              onInput={(e) => {
                if (e.target.value === "") {
                  this.clearFilter(0);
                } else {
                  this.filterMetadata("name");
                }
              }}
              ref={this.filterInputRef}
              id="exploreSearchInput"
              type="text"
              placeholder="Eg. 2068"
            />
            <i
              onClick={() => this.filterMetadata("name")}
              className="fas fa-search"
            ></i>
          </div>

          <button
            onClick={
              this.state.isFiltered ? this.clearFilter : this.toggleFilterPopup
            }
            id="exploreFilterBtn"
          >
            {" "}
            {this.filterBtnContent()}{" "}
          </button>
        </div>
        <div id="exploreItems">
          {/*{this.state.isFiltered ?
                        this.state.currentFilteredMetadata.map((frog, i) => (<ExploreTile key={i} frog={frog} />))
                        :
                    this.state.currentMetadata.map((frog, i) => (<ExploreTile key={i} frog={frog} />))}*/}
          {this.state.isFiltered
            ? this.state.currentFilteredMetadata.map((frog, i) => (
                <ExploreTile key={i} frog={frog} />
              ))
            : this.state.currentMetadata.map((frog, i) => (
                <ExploreTile key={i} frog={frog} />
              ))}
        </div>

        {/*<button id="loadMoreBtn" onClick={this.state.isFiltered ? this.loadMoreFilteredMetadata : (this.state.isTraitsFiltered ? this.loadMoreTraisFilteredMetadata : this.loadMoreMetadata)}>LOAD MORE</button>*/}
        <button
          id="loadMoreBtn"
          onClick={
            this.state.isFiltered
              ? this.loadMoreFilteredMetadata
              : this.loadMoreMetadata
          }
        >
          LOAD MORE
        </button>
      </div>
    );
  }
}

export default Explore;
